













import { Vue, Component, Prop } from 'vue-property-decorator';
import { RouteNames } from './_routes';
import { Subscription } from 'vue-rx-decorators';
import { Cache } from '../../common/cache';
import { Facilities } from '@lantern/lantern-sdk';
import { log } from 'util';

@Component
export default class TabsComponent extends Vue {

    @Subscription(() => Cache.instance.facility)
    facility!: Facilities.Document | null;

    @Subscription(() => Cache.instance.isAdmin)
    isAdmin!: boolean | undefined;

    links: { route: RouteNames; label: string; secureViewOnly: boolean; access: boolean }[] = [
        {
            route: RouteNames.inmates,
            label: 'Manual Import',
            secureViewOnly: false,
            access: true
        },
        {
            route: RouteNames.import,
            label: 'Import from CSV',
            secureViewOnly: false,
            access: true
        },
        {
            route: RouteNames.rules,
            label: 'Automated Rules',
            secureViewOnly: false,
            access: true
        },
        {
            route: RouteNames.apps,
            label: 'Import App Assignment',
            secureViewOnly: true,
            access: true
        },
        {
            route: RouteNames.sessions,
            label: 'Past Sessions',
            secureViewOnly: false,
            access: true
        }
    ]

    get currentRouteName() {
        return this.$route.name;
    }

    created() {
        this.links.forEach(e => {
            if (e.route === RouteNames.rules || e.route === RouteNames.apps) e.access = this.isAdmin !== undefined ? this.isAdmin : true;
        });
    }
}
